<template>
  <div class="pt-3" v-if="meterType">
    <div class="d-flex justify-space-between mb-2 align-items-center">
      <div>
        <h2 v-if="meterType == 'water'" class="mb-0 ps-3 font-weight-bold">{{ $t('meter.water_meter_list') }}</h2>
        <h2 v-else-if="meterType == 'elec'" class="mb-0 ps-3 font-weight-bold">{{ $t('meter.elec_meter_list') }}</h2>
      </div>
      <div class="d-flex align-center justify-end gap-2">
        <v-btn v-if="!isShowSelect" class="white--text mx-1" color="info" outlined :disabled="isMainLoading" @click="seleteArea()">
          <v-icon class="me-2">mdi-cog</v-icon>{{ $t('meter.setting_multiple_meter') }}
        </v-btn>
        <template v-if="isShowSelect">
          <v-btn class="white--text mx-1" :disabled="isMainLoading || seleteMeters.length == 0" color="info" outlined
            @click="addBillingSettings()">
            <v-icon class="me-2">mdi-plus</v-icon>
            {{ $t('meter.setting_all_meter', { count: seleteMeters.length }) }}
          </v-btn>
          <v-btn class="white--text mx-1" :disabled="isMainLoading || seleteMeters.length == 0" color="error" outlined
            @click="removeBillingSettings()">
            <v-icon class="me-2">mdi-trash-can</v-icon>
            {{ $t('delete_settings') }} {{ seleteMeters.length }} {{ $t('digit') }}
          </v-btn>
          <v-btn class="error mx-1" :disabled="isMainLoading"
            @click="seleteAreas = []; seleteMeters = []; isShowSelect = false">{{ $t('cancel') }}</v-btn>
        </template>
        <v-btn color="info" elevation="0" @click="meterDialog = true" :disabled="isLoading" v-if="meterType == 'water' ||
          meterType == 'elec'
          ">
          <v-icon left>mdi-plus</v-icon>{{ $t('meter.add_meter') }}
        </v-btn>
        <form-meter v-model="meterDialog" event="create" :type="meterType" @onSave="saveMeter"></form-meter>
      </div>
    </div>
    <v-card flat outlined :loading="isMainLoading" min-height="30">
      <v-data-table :loading="isBillingLoading || isMainLoading" v-model="seleteMeters" :items-per-page="10"
        :headers="headers" :items="meterSettingItems" class="elevation-0 outlined" sort-by="area.order"
        item-key="objectId" :show-select="isShowSelect">
        <template v-slot:body.prepend>
          <tr>
            <td class="text-center" :colspan="isShowSelect ? 2 : 1">
              <v-icon>mdi-filter-multiple-outline</v-icon>
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.areaName" type="text" :label="$t('area.area_name')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.meterName" type="text" :label="$t('meter.meter_name')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.serviceName" type="text" :label="$t('service')" solo dense hide-details />
            </td>
            <td class="ps-0">
              <v-autocomplete v-model="filterData.unit" :items="[{ text: $t('all'), value: '' }, ...filterOption.unit]"
                :label="$t('meter.method_calculate')" item-text="text" solo dense hide-details clearable
                :no-data-text="$t('meter.no_method_calculate')"></v-autocomplete>
            </td>
            <td class="ps-0">
              <v-text-field v-model="filterData.price" class="input-right input-disable-appearance" type="text"
                :label="$t('price')" solo dense hide-details />
            </td>
            <td class="ps-0"></td>
            <td class="ps-0 pe-0">
              <v-text-field v-model="filterData.total" class="input-right input-disable-appearance" type="text"
                :label="$t('total')" solo dense hide-details />
            </td>
            <td class="ps-0"></td>
            <td class="ps-0"></td>
          </tr>
        </template>
        <template v-slot:item.index="{ index }">{{ index + 1 }}</template>
        <template v-slot:item.areaName="{ item }">
          <div class="text-nowrap-table area-name">
            {{ item.area ? item.area.name : '-' }}
          </div>
        </template>
        <template v-slot:item.nameText="{ item }">
          <div class="text-start">
            <span right class="px-3 rounded info white--text" v-if="!item.isMain">{{ $t('additional') }}</span>
            {{ item.nameText }}
            <v-btn color="warning" icon @click="openEditDialog(item)">
              <v-icon size="15">mdi-pencil</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.serviceText="{ item }">
          <template v-if="item.billingSetting && item.billingSetting.length">
            <div v-for="(prod, index) in item.billingSetting" :key="`${item.objectId}_name_${index}`" class="py-1 text-start">
              <div class="text-no-wrap" >{{ prod.accountingProduct.name }}</div>
            </div>
          </template>
          <div v-else class="py-1 text-start">-</div>
        </template>
        <template v-slot:item.costText="{ item }">
          <template v-if="item.billingSetting && item.billingSetting.length">
            <div v-for="(prod, index) in item.billingSetting" :key="`${item.objectId}_cost_${index}`" class="py-1  text-end">
              <div v-if="prod.type != 'step'">
              {{ prod.cost | currency }}
              </div>
              <div class="text-end" v-else>-</div>
            </div>
          </template>
          <div v-else class="py-1">-</div>
        </template>
        <template v-slot:item.discount="{ item }">
          <div v-for="(prod, index) in item.billingSetting" :key="`${item.objectId}_discount_${index}`" class="py-1  text-end">
            <div v-if="prod.type != 'step'">
              {{ prod.discount || 0 | currency }}{{ prod.discountType == 2 ? '%' : '' }}
            </div>
            <div class="text-end" v-else>-</div>
          </div>
        </template>
        <template v-slot:item.totalText="{ item }">
          <template v-if="item.billingSetting && item.billingSetting.length">
            <div v-for="(prod, index) in item.billingSetting" :key="`${item.objectId}_total_${index}`" class="py-1  text-end">
              <template v-if="prod.type != 'step'">
                <template v-if="prod.discountType == 2">{{ $helper.round(prod.cost - (prod.cost * (prod.discount || 0) /
                  100)) | currency }}
                </template>
                <template v-else>{{ prod.cost - (prod.discount || 0) | currency }}</template>
              </template>
              <div class="text-end" v-else>-</div>
            </div>
          </template>
          <div v-else class="py-1">-</div>
        </template>
        <template v-slot:item.unitText="{ item }">
          <template v-if="item.billingSetting && item.billingSetting.length">
            <div v-for="(prod, index) in item.billingSetting" :key="`${item.objectId}_unit_${index}`"
              class="text-no-wrap meter-unit py-1 text-start">
              <v-tooltip top color="bgTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    style="padding: 0"
                  >
                    <v-icon color="info" class="sm-icon">
                      mdi-information
                    </v-icon>
                    {{ prod.typeString }}
                  </div>
                </template>
                <div class="tooltip-box">
                  <div> {{ $t('detail') }} </div>
                  <v-divider class="mt-2 mb-3" color="white"></v-divider>
                  <div class="d-flex justify-between mb-3">
                    <div>{{ $t('service') }}</div>
                    <div><b>
                      {{
                      `
                      [${prod.accountingProduct.typeString}]
                      ${prod.accountingProduct.name} @${prod.accountingProduct.unit}
                      `
                      }}
                    </b></div>
                  </div>
                  <div class="d-flex justify-between mb-3">
                    <div>{{ $t('meter.method_calculate') }}</div>
                    <div>
                      <b>
                        {{ prod.typeString }}
                      </b>
                    </div>
                  </div>
                  <div v-if="prod.type == 'step'">
                    <div v-for="(step,inx) in prod.step" :key="inx">
                      <div v-if="inx != prod.step.length - 1">
                        <div class="mb-3 fw-500">• {{ $t('meter.meter_unit_from') }} {{$helper.toArabic(step.minUnit)}} - {{$helper.toArabic(step.maxUnit)}} {{step.calCulateType == "all" ? $t('meter.all')  : $t('meter.per_unit')}} {{ $helper.toArabic(step.cost) }} {{ $helper.currencyThEn(tabType) }}</div>
                      </div>
                      <div v-else>
                        <div class="mb-3 fw-500">
                          <strong>• {{ $t('meter.unit_from_min', { minUnit: $helper.toArabic(step.minUnit) }) }} </strong> {{step.calCulateType == "all" ? $t('meter.all')  : $t('meter.per_unit')}} {{ $helper.toArabic(step.cost) }} {{ $helper.currencyThEn(tabType) }}</div>
                      </div>
                    </div>
                    <div v-if="prod.minimumCost">
                      <div class="border-dashed"></div>
                      <div class="d-flex justify-between">
                        <div><b>{{ $t('meter.minimum_price') }}</b></div>
                        <div><b>{{ $helper.toArabic(prod.minimumCost) }} {{ $helper.currencyThEn(tabType) }}</b></div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="prod.type == 'minimum_unit'">
                    <div class="d-flex justify-between mb-2">
                      <div class="fw-500">• {{ $t('meter.minimum_unit') }}</div>
                      <div><b>{{$helper.toArabic(prod.minimumUnit)}} {{ $t('meter.unit_another_format') }}</b></div>
                    </div>
                    <div class="d-flex justify-between mb-2">
                      <div class="fw-500">• {{ $t('meter.cost_total') }} </div>
                      <div><b>{{$helper.toArabic(prod.minimumCost)}} {{ $helper.currencyThEn(tabType) }}</b></div>
                    </div>
                  </div>
              </div>
              </v-tooltip>
            </div>
          </template>
          <div v-else>-</div>
        </template>
        <template v-slot:item.action="{ item }">
          <div v-for="(prod, index) in item.billingSetting" :key="`${item.objectId}_action_${index}`" class="py-0 ">
            <div class="text-no-wrap">
              <v-btn small color="yellow darken-2" icon @click="selectUpdate(prod, 'facility', item.area, item)">
                <v-icon size="20">mdi-pencil</v-icon>
              </v-btn>
              <v-btn small color="error" icon @click="removeDialogId(prod.objectId, prod)">
                <v-icon size="20">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </template>
        <template v-slot:item.add="{ item }">
          <div class="text-no-wrap">
            <v-btn color="info" elevation="0" rounded small @click="addBillingSetting(item.area, 'facility', item)">
              <v-icon left>mdi-plus</v-icon>{{ $t('add_setting') }}
            </v-btn>
            <v-btn color="error" elevation="0" :disabled="item.isMain" rounded small  @click="selectRemoveMeter(item.objectId)" class="ms-2">
              <v-icon left>mdi-close</v-icon>{{ $t('meter.delete_meter') }}
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <form-billing-setting v-model="billingDialog" :area="tempArea" @onSave="onSaveBilling" 
        @onSaveUpdate="saveUpdateBilling" :billingType="billingType" :event="event" :billingSetting="tempBillingSetting"
        :meter="tempMeter" :meterType="meterType" :isLoading="isBillingLoading" :closeDialogConfirm="true" @onCloseDialog="dialogCloseDialogConfirm = true"
        :tabType="tabType" @onDelete="saveDeleteBilling"></form-billing-setting>
    </v-card>

    <v-dialog v-model="isEditDialog" max-width="400px">
      <v-card v-if="editItem">
        <v-card-title class="justify-between info text-white">
          {{ $t('meter.edit_meter') }}
          <v-btn color="white" icon @click="isEditDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="bg-white px-5 pt-4">
          <span>{{ $t('meter.meter_name') }}</span>
          <v-text-field v-model="editItem.name" solo flat background-color="grey lighten-4" hide-details></v-text-field>
        </div>
        <div class="flex justify-end p-5">
          <!-- v-btn elevetion-0 -->
          <v-btn color="primary" elevation="0" @click="saveEditItem()" :loading="isEditLoading">{{ $t('save') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <confirm-dialog @onOk="removeBilling(removeId)" v-model="removeDialog" :disabled="isLoading"
      :loading="isLoading"></confirm-dialog>
    <confirm-dialog v-model="removeMeterDialog" @onOk="removeMeter(removeId)" :title="$t('validate.you_want_to_delete_meter')"></confirm-dialog>
    <LoadingPercentDialog v-model="isLoadingDialog" :final="loadingFinal" :initial="loadingInitial" />

    <ConfirmDialogComponent v-model="dialogCloseDialogConfirm" :title="$t('close_window')"
      :text="$t('validate.confirm_to_close_window')"
      :textClass="'text-center fs-14'"
      :textBtnOk="$t('confirm')" 
      :textBtnCancel="$t('cancel')"
      :type="'error'"
      @onOk="billingDialog = false; dialogCloseDialogConfirm = false"
      @onCancel="dialogCloseDialogConfirm = false" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmDialog from "./ConfirmDialog.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import FormBillingSetting from "./FormBillingSetting.vue";
import LoadingPercentDialog from "@/components/LoadingPercentDialog.component";
import FormMeter from "./FormMeter.vue";
export default {
  components: {
    FormBillingSetting,
    ConfirmDialog,
    LoadingPercentDialog,
    FormMeter,
    ConfirmDialogComponent
  },
  props: {
    isMainLoading: Boolean,
    marketId: String,
    meterSettingItems: Array,
    meterType: String,
    tabType: String
  },
  computed: {
    ...mapGetters({
      meterSettings: "meter/getMeterSettings",
      billingSettings: "billingSetting/getBillingSettingsWithLabel"
    }),
  },
  watch: {
    meterSettingItems: {
      handler() {
        this.filterOption.unit = [];
        this.billingSettings.forEach(val => {
          if (!this.filterOption.unit.includes(val.typeString)) {
            this.filterOption.unit.push(val.typeString)
          }
        })
      },
    },
    meterType(type) {
      if (type == "water" || type == "elec") {
        this.initData();
      }
    }
  },
  data() {
    return {
      headers: [],
      removeAreaId: "",
      billingDialog: false,
      billingType: "",
      event: "",
      tempBillingSetting: {},
      removeId: "",
      removeDialog: false,
      tempMeter: {},
      removeMeterDialog: false,
      isBillingLoading: false,
      tempArea: null,
      editItem: {},
      isEditDialog: false,
      isEditLoading: false,
      isShowSelect: false,
      seleteAreas: [],
      seleteMeters: [],
      isLoadingDialog: false,
      loadingInitial: 0,
      loadingFinal: 0,
      isLoading: false,
      formBill: null,
      filterData: {
        areaName: null,
        meterName: null,
        serviceName: null,
        unit: null,
        price: null,
        total: null
      },
      filterOption: {
        unit: [],
      },
      meterDialog: false,
      dialogCloseDialogConfirm : false,
    };
  },
  created() {
    this.headers = [
        {
          value: "index",
          text: this.$t('rank'),
          width: "5%",
          align: "center",
          sortable: false
        },
        {
          value: "area.name",
          text: this.$t('area.area_name'),
          width: "10%",
          align: "center",
          filter: d =>
            this.filterData.areaName
              ? d.toLowerCase().includes(this.filterData.areaName.toLowerCase())
              : d
        },
        {
          value: "nameText",
          text: this.$t('meter.meter_name'),
          align: "center",
          width: "15%",
          filter: d =>
            this.filterData.meterName
              ? d
                .toLowerCase()
                .includes(this.filterData.meterName.toLowerCase())
              : d
        },
        {
          value: "serviceText",
          text: this.$t('area.service'),
          align: "center",
          sortable: false,
          filter: d =>
            this.filterData.serviceName
              ? d
                .toLowerCase()
                .includes(this.filterData.serviceName.toLowerCase())
              : d
        },
        {
          value: "unitText",
          text: this.$t('area.method_calculate'),
          sortable: false,
          align: "center",
          width: "160px",
          filter: d =>
            this.filterData.unit
              ? d.toLowerCase().includes(this.filterData.unit.toLowerCase())
              : d
        },
        {
          value: "costText",
          text: this.$t('bill.price'),
          align: "center",
          sortable: false,
          width: "5%",
          filter: d =>
            this.filterData.price
              ? d.toLowerCase().includes(this.filterData.price.toLowerCase())
              : d
        },
        {
          value: "discount",
          text: this.$t('bill.discount'),
          align: "center",
          sortable: false,
          width: "5%"
        },
        {
          value: "totalText",
          text: this.$t('bill.total'),
          align: "center",
          sortable: false,
          width: "7%",
          filter: d =>
            this.filterData.total
              ? d.toLowerCase().includes(this.filterData.total.toLowerCase())
              : d
        },
        {
          value: "action",
          text: "",
          align: "center",
          sortable: false,
          width: "5%"
        },
        {
          value: "add",
          text: "",
          align: "center",
          sortable: false,
          width: "15%"
        }
    ];
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.filterData = {
        areaName: null,
        meterName: null,
        serviceName: null,
        unit: null,
        price: null,
        total: null
      };
      this.onInitMeterSetting();
    },
    saveMeter(formData) {
      this.$emit("onSaveMeter", formData);
    },
    onInitMeterSetting() {
      this.$emit("onInitMeterSetting");
    },
    openEditDialog(item) {
      this.editItem = { name: item.name, id: item.objectId };
      this.isEditDialog = true;
    },
    async saveEditItem() {
      try {
        this.isEditLoading = true;
        const data = await this.$store.dispatch(
          "meter/updateMeter",
          this.editItem
        );
        this.initData();
        this.isEditDialog = false;
        this.isEditLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    selectRemoveMeter(id) {
      this.removeId = id;
      this.removeMeterDialog = true;
    },
    removeDialogId(id, bill) {
      this.removeId = id;
      this.removeDialog = true;
      this.removeAreaId = bill.area.objectId;
    },
    async removeMeter() {
      try {
        this.isBillingLoading = true;
        const saveBilling = await this.$store.dispatch("meter/removeMeter", {
          id: this.removeId
        });
        this.isBillingLoading = false;
        this.removeMeterDialog = false;
        this.initData();
      } catch (err) {
        this.isBillingLoading = false;
        this.removeMeterDialog = false;
      }
    },
    async removeBilling() {
      try {
        this.isLoading = true;
        const saveBilling = await this.$store.dispatch(
          "billingSetting/removeBillingSetting",
          { id: this.removeId }
        );
        this.removeId = "";
        this.removeAreaId = "";
        this.removeDialog = false;
        this.isLoading = false;
        this.initData();
      } catch (err) {
        console.log(err);
        this.removeId = "";
        this.isLoading = false;
        this.removeDialog = false;
        this.removeAreaId = "";
      }
    },
    selectUpdate(billingSetting, type, area, meter) {
      this.billingType = type;
      this.event = "update";
      this.tempBillingSetting = billingSetting;
      this.tempArea = area;
      this.tempMeter = meter;
      this.isSaveList = false;
      this.billingDialog = true;
    },
    onSaveBilling(formData) {
      if (this.isSaveList) {
        this.saveBillingList(formData);
      } else {
        this.saveBilling(formData);
      }
    },
    async saveBilling(formData) {
      try {
        this.isBillingLoading = true;
        await this.$store.dispatch(
          "billingSetting/createBillingSetting",
          {
            ...formData,
            currencyCode: this.tabType
          } 
        );
        this.billingDialog = false;
        this.isBillingLoading = false;
        this.initData();
      } catch (err) {
        console.log("error", err);
        this.isBillingLoading = false;
      }
    },
    async saveBillingList(formData) {
      try {
        this.isBillingLoading = true;
        this.isLoadingDialog = true;
        this.loadingInitial = 0;
        this.loadingFinal = 0;
        let postData = formData;
        let checkStep = [];
        this.loadingInitial = this.seleteMeters.length;
        for (let meter of this.seleteMeters) {

          postData.meterId = meter.objectId;
          postData.areaId = meter.area.objectId;
          let billingSettings = this.getBillingByMeterId(meter.objectId);
          let billingSetting = billingSettings.find(
            d =>
              d.accountingProduct.objectId == formData.accountingProductId &&
              d.type == formData.type
          );
          if (formData && formData.cost == 0 && formData.discount == 0 || formData.type == 'step') {
            if (formData.type == "step") {
              if(formData.step.length > 0){
                formData.step.forEach((item, inx) => {
                  if ((item.cost <= 0 && item.maxUnit <= 0 && formData.minimumCost <= 0) && inx !== formData.step.length - 1) {
                    checkStep.push(item); 
                  }
                });
                if (checkStep.length > 0) {
                  const saveBilling = await this.$store.dispatch(
                    "billingSetting/removeBillingSetting",
                    { id: billingSetting.objectId }
                  );
                }else{
                  if (billingSetting) {
                    postData.id = billingSetting.objectId;
                    await this.$store.dispatch(
                      "billingSetting/updateBillingSetting",
                      {
                        ...postData,
                        currencyCode: this.tabType
                      }
                    );
                  } else {
                    await this.$store.dispatch(
                      "billingSetting/createBillingSetting",
                      {
                        ...postData,
                        currencyCode: this.tabType
                      }
                    );
                  }
                }
              }
            }else if(formData.type != "step" && billingSetting){
              const saveBilling = await this.$store.dispatch(
                "billingSetting/removeBillingSetting",
                { id: billingSetting.objectId }
              );
            }
          } else if (formData && (formData.cost > 0 || formData.discount > 0)) {
            if (billingSetting) {
              postData.id = billingSetting.objectId;
              await this.$store.dispatch(
                "billingSetting/updateBillingSetting",
                {
                  ...postData,
                  currencyCode: this.tabType
                }
              );
            } else {
              await this.$store.dispatch(
                "billingSetting/createBillingSetting",
                {
                  ...postData,
                  currencyCode: this.tabType
                }
              );
            }
          }
          this.loadingFinal++;
        }

        this.isShowSelect = false;
        this.seleteAreas = [];
        this.seleteMeters = [];

        this.billingDialog = false;
        this.isLoadingDialog = false;
        this.isBillingLoading = false;
        this.initData();
      } catch (err) {
        console.log(err);
        this.isBillingLoading = false;
      }
    },
    async saveUpdateBilling(value) {
      try {
        const checkStep = [];
        this.isBillingLoading = true;
        if (value && value.cost == 0 && value.discount == 0 || value.type == "step") {
          if (value.type == "step") {
            if(value.step.length > 0){
              value.step.forEach((item, inx) => {
                if ((item.cost <= 0 && item.maxUnit <= 0 && value.minimumCost <= 0) && inx !== value.step.length - 1) {
                  checkStep.push(item); 
                }
              });
              if (checkStep.length > 0) {
                const saveBilling = await this.$store.dispatch(
                  "billingSetting/removeBillingSetting",
                  { id: value.billingSettingId }
                );
              }else{
                const saveBilling = await this.$store.dispatch(
                  "billingSetting/updateBillingSetting",
                  {
                    ...value,
                    currencyCode: this.tabType
                  }
                );
              }
            }
          }else if(value.type != "step"){
            const saveBilling = await this.$store.dispatch(
              "billingSetting/updateBillingSetting",
              {
                ...value,
                currencyCode: this.tabType
              }
            );
          }
        } else if (value && (value.cost > 0 || value.discount > 0)) {
          const saveBilling = await this.$store.dispatch(
            "billingSetting/updateBillingSetting",
            {
              ...value,
              currencyCode: this.tabType
            }
          );
        } 
        this.billingDialog = false;
        this.isBillingLoading = false;
        this.initData();
      } catch (err) {
        this.isBillingLoading = false;
      }
    },

    async saveDeleteBilling(formData) {
      try {
        this.isBillingLoading = true;
        this.isLoadingDialog = true;
        this.loadingInitial = 0;
        this.loadingFinal = 0;
        this.loadingInitial = this.seleteMeters.length;
        for (let meter of this.seleteMeters) {
          let billingSettings = this.getBillingByMeterId(meter.objectId);
          let billingSetting = billingSettings.find(
            d =>
              d.accountingProduct.objectId == formData.accountingProductId &&
              d.type == formData.type
          );
          if (billingSetting) {
            const saveBilling = await this.$store.dispatch(
              "billingSetting/removeBillingSetting",
              { id: billingSetting.objectId }
            );
          }
          this.loadingFinal++;
        }
        this.isShowSelect = false;
        this.seleteAreas = [];
        this.seleteMeters = [];
        this.billingDialog = false;
        this.isLoadingDialog = false;
        this.isBillingLoading = false;
        this.initData();
      } catch (err) {
        console.log(err);
        this.isBillingLoading = false;
      }
    },
    
    addBillingSetting(area, type, meterObj = {}) {
      this.billingType = type;
      this.event = "create";
      this.tempMeter = meterObj;
      this.tempArea = area;
      this.tempBillingSetting = null;
      this.isSaveList = false;
      this.billingDialog = true;
    },
    getBillingByMeterId(id) {
      return this.billingSettings.filter(i => i?.meter?.objectId === id);
    },
    seleteArea() {
      this.seleteAreas = [];
      this.isShowSelect = true;
    },
    addBillingSettings() {
      this.tempArea = null;
      (this.tempMeter = null), (this.tempBillingSetting = null);
      this.event = "create";
      this.billingType = "facility";
      this.isSaveList = true;
      this.billingDialog = true;
    },
    removeBillingSettings() {
      this.tempArea = null;
      (this.tempMeter = null), (this.tempBillingSetting = null);
      this.event = "delete";
      this.billingType = "facility";
      this.isSaveList = true;
      this.billingDialog = true;
    }
  }
};

</script>

<style>
.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}
</style>

<style lang="scss" scoped>
.text-nowrap-table.meter-unit {
  width: 150px;
}

.sm-icon{
  font-size: 17px !important;
}

.border-dashed{
  border: 1px dashed #fff !important;
  margin: 8px 0 !important;
}

.tooltip-box {
  // max-width: 300px !important;
  min-width: 380px !important;
}
.fw-500{
  font-weight: 500;
}
</style>